var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 4h10a4 4 0 014 4v46a4 4 0 01-4 4H18a4 4 0 01-4-4z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 9h-4a1 1 0 010-2h4a1 1 0 010 2zM54 9h-2a1 1 0 010-2h2a1 1 0 010 2z",
    fill: "#9fc9d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 23h-7a1 1 0 010-2h7a1 1 0 010 2zM51 28h-7a1 1 0 010-2h7a1 1 0 010 2zM51 33h-7a1 1 0 010-2h7a1 1 0 010 2z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0h27a4 4 0 014 4v46a4 4 0 01-4 4H4a4 4 0 01-4-4V13z",
    fill: "#b0d3f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0v9a4 4 0 01-4 4H0z",
    fill: "#90bae1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 5h-6a1 1 0 010-2h6a1 1 0 010 2zM40 5h-2a1 1 0 010-2h2a1 1 0 010 2z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2980ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 19H8a1 1 0 010-2h9a1 1 0 010 2zM37 19H22a1 1 0 010-2h15a1 1 0 010 2zM37 24h-9a1 1 0 010-2h9a1 1 0 010 2zM23 24H8a1 1 0 010-2h15a1 1 0 010 2zM17 29H8a1 1 0 010-2h9a1 1 0 010 2zM37 29H22a1 1 0 010-2h15a1 1 0 010 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.467 42.6l-6.667-5a.5.5 0 00-.8.4v1.5a.5.5 0 01-.5.5h-11a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h11a.5.5 0 01.5.5V48a.5.5 0 00.8.4l6.667-5a.5.5 0 000-.8z",
    fill: "#ff5364"
  }))));
}

export default __webpack_public_path__ + "ef21cdce8fa40cd51f0df572f54c4ef2.svg";
export { SvgCopyFile as ReactComponent };